import * as yup from "yup";

export const REVIEW_COMMENT_MAX_LENGTH = 1000;

const RATING_MESSAGE = "Изберете оценка от 1 до 5";

export interface IReviewFormModel {
  rating: number;
  comment: string;
}

export const reviewFormSchema: yup.ObjectSchema<IReviewFormModel> = yup.object({
  rating: yup
    .number()
    .typeError(RATING_MESSAGE)
    .required(RATING_MESSAGE)
    .min(1, RATING_MESSAGE)
    .max(5, RATING_MESSAGE),
  comment: yup
    .string()
    .defined()
    .max(
      REVIEW_COMMENT_MAX_LENGTH,
      `Максимум ${REVIEW_COMMENT_MAX_LENGTH} символа`,
    ),
});

export const reviewFormDefaultValues: IReviewFormModel = {
  rating: 0,
  comment: "",
};
